import { render, staticRenderFns } from "./OverallStatusIcon.vue?vue&type=template&id=50924a7b"
import script from "./OverallStatusIcon.vue?vue&type=script&lang=ts"
export * from "./OverallStatusIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports